var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.wrapper},_vm._l((_vm.pages),function(page){
var _obj;
return _c('div',{key:page,class:( _obj = {}, _obj[_vm.$style.circle] = true, _obj[_vm.$style.active] = _vm.index === page, _obj )})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }